import { cva } from "class-variance-authority";

export const skeletonVariants = cva(
  "animate-pulse bg-gray-200",
  {
    variants: {
      variant: {
        default: "rounded-md",
        circle: "rounded-full",
        text: "rounded-sm",
        card: "rounded-lg",
        button: "rounded-md",
      },
      size: {
        xs: "h-3",
        sm: "h-4", 
        base: "h-5",
        lg: "h-6",
        xl: "h-8",
        "2xl": "h-10",
        "3xl": "h-12",
        icon: "h-5 w-5",
        "icon-sm": "h-4 w-4",
        "icon-lg": "h-6 w-6",
        button: "h-10 w-24",
        card: "h-40",
        avatar: "h-12 w-12",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "base",
    },
  }
);

export const SKELETON_STYLES = {
  base: "animate-pulse rounded-md bg-gray-200",
  section: "w-full animate-pulse bg-gray-200",
  rounded: "rounded-lg",
} as const; 